// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9066) return "static/chunks/dc112a36.f05ff3686e3b9e31.js";
	if (chunkId === 7853) return "static/chunks/7853.62d6ac8c08e9f41a.js";
	if (chunkId === 2748) return "static/chunks/2748.cbc8a6f5cb8bba98.js";
	if (chunkId === 683) return "static/chunks/683.65cea71b0c816113.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2266":"870fdd6f","2545":"c16f53c3"}[chunkId] || chunkId) + "-" + {"153":"9e84306c5e0a2e99","406":"027f01fa517587d6","861":"00478c0584440170","1313":"8b21a846d2013109","2230":"2e2cf587de09e2cc","2266":"a301b4dfc4403aa2","2545":"717dcf2f0b2beba9","2870":"445feeff12babe88","5817":"a61790592cc8fec8","7303":"58c85d22c54f0461"}[chunkId] + ".js";
};